import styled from 'styled-components';

import { errorColorLight } from '~theme';

const Chevron = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
  flex-grow: 1;
  font-size: 16px;
  margin-left: 8px;
  color: ${props => (props.editing ? errorColorLight : 'white')};

  & > i {
    padding-top: 2px;
  }
`;

export default Chevron;
